import { render } from "./ManuscriptsOverview.vue?vue&type=template&id=50fd4998&ts=true"
import script from "./ManuscriptsOverview.vue?vue&type=script&lang=ts"
export * from "./ManuscriptsOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__